import { render } from "./Home.vue?vue&type=template&id=d3d4d0a4"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=d3d4d0a4&lang=css"
script.render = render

export default script